import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useWindows } from '../../hooks/useWindows';
import WindowsDashboard from '../../components/admin/WindowsDashboard';

const VentanasPage = () => {
  const { windows, error, isLoading } = useWindows();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar ventanas.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <WindowsDashboard
        windows={windows}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de ventanas:', newOrder);
        }}
      />
    </Box>
  );
};

export default VentanasPage;